var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircleIcon = function SvgHelpCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0057B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.697 7.625a2.375 2.375 0 0 1 4.615.792c0 1.583-2.375 2.375-2.375 2.375m.064 3.167h.008M17.917 10a7.917 7.917 0 1 1-15.833 0 7.917 7.917 0 0 1 15.833 0"
  })));
};
export default SvgHelpCircleIcon;